module.exports = __webpack_public_path__ + "img/home_active.bd794855.svg";